
function Section2() {
  return (
    <div>
    <div id="whyBuyLoneyBones" className='section is-relative p-0' style={{
    }}>
        <div className='d1 columns p-6'>
            <div className='d2 column is-two-thirds p-6'>
                <h3 style={{
                    fontSize: '80px',
                    lineHeight: '80px',
                    color: '#FEDE91'
                }} className='font-trashhand'>
                    WHY BUY <br/> LONELY BONES ?
                </h3>
                <p style={{
                    color: '#E1DAB9',
                    fontSize: '30px',
                    lineHeight: '50px',
                    marginBottom: '150px'
                }} className='is-uppercase font-trashhand mt-5'>
                    the lonely bones club is a collection of 4,444 lonely heartbroken unique handmade nfts. digital collectibles living on the ethereum blockchain. your “lonely bone” is your membership card into the lonely bones club, grants access to member-only benefits and many more.
                </p>
            </div>
        </div>
        <div className="mt-6"></div>
    </div>
    <div id="spacerFix"></div>
    </div>
  )
}

export default Section2